<path
    fill="#EEEFF2"
    d="M71.5669 127c32.8001 0 59.4001-26.4 59.4001-59s-26.6-59-59.4001-59c-32.8 0-59.4 26.4-59.4 59s26.6 59 59.4 59ZM129.449 39.8c2.265 0 4.1-1.8357 4.1-4.1 0-2.2644-1.835-4.1-4.1-4.1-2.264 0-4.1 1.8356-4.1 4.1 0 2.2643 1.836 4.1 4.1 4.1ZM125.349 26.5c1.547 0 2.8-1.2536 2.8-2.8 0-1.5464-1.253-2.8-2.8-2.8-1.546 0-2.8 1.2536-2.8 2.8 0 1.5464 1.254 2.8 2.8 2.8Z"
/>
<path
    fill="#EDEEF1"
    d="M11.9492 35.7c1.5464 0 2.8-1.2536 2.8-2.8 0-1.5464-1.2536-2.8-2.8-2.8-1.5464 0-2.79997 1.2536-2.79997 2.8 0 1.5464 1.25357 2.8 2.79997 2.8ZM5.64922 97.3c2.87188 0 5.19998-2.3281 5.19998-5.2s-2.3281-5.2-5.19998-5.2S.449219 89.2281.449219 92.1s2.328121 5.2 5.200001 5.2Z"
/>
<path
    fill="url(#a)"
    d="M117.066 60.2999V96.4c0 7.5-6.1 13.6-13.7 13.6H39.9656c-7.5 0-13.6-6-13.7-13.5V60.0999c0-.2 0-.3999.1-.5999.1-.3.2-.5.3-.8l17-32.5c.6-1.3 1.9-2 3.3-2h49.3c1.4 0 2.6.7 3.3 2l17.0004 32.5c.1.2.2.5.3.8.2.2.2.5.2.7999Z"
/>
<g filter="url(#b)">
    <path
        fill="#F6F7FA"
        fill-rule="evenodd"
        d="M56.9668 29.8v-6.3c0-1.1.8-2 2-2h25.6c1.1 0 2 .8 2 2v6.3h6.6c1.4 0 2.5 1.2 2.5 2.5v7.3001h2.3984c1.5 0 2.7998 1.3 2.7998 2.7v6.8h2.5c1.7 0 3 1.4 3 2.9v33c-.1 1.7-1.3 3-3 3H40.3652c-1.7 0-3-1.4-3-2.9v-33.1c0-1.7 1.4-2.9 3-2.9h2.5v-6.8c0-1.5 1.3-2.7 2.8-2.7h2.3016V32.3c0-1.4 1.2-2.5 2.5-2.5h6.5Z"
        clip-rule="evenodd"
    />
</g>
<g filter="url(#c)">
    <path
        fill="url(#d)"
        d="M117.066 60.3v39.8c0 5.5-4.4 9.9-10 9.9H36.2656c-5.5 0-10-4.4-10-9.9v-40c0-.2 0-.4.1-.6h22.8c3.4 0 6.2 2.7 6.2 6.2 0 1.7.7 3.3 1.8 4.4 1.2 1.2 2.6 1.8 4.4 1.8h20.3c3.4 0 6.2-2.7 6.2-6.2 0-1.7.7-3.3 1.8-4.4 1.2-1.2 2.6-1.8 4.3-1.8h22.7004c.2.2.2.5.2.8Z"
    />
</g>
<path
    fill="url(#e)"
    d="M90.7741 106.1c-.4 1.7-1 3.5-1.7 5-1.9 3.7-4.9 6.6-8.6 8.5-3.8 1.9-8.3 2.7-12.8 1.7-10.7-2.3-17.5-12.6-15.3-23.1998 2.2-10.6 12.5-17.5 23.1-15.2 3.8.8 7.1 2.7 9.9 5.3 4.8 4.7 6.7 11.4 5.4 17.8998Z"
/>
<path
    fill="#fff"
    d="M76.6143 100.615h-3.6649v-3.6646c0-.7329-.5701-1.3845-1.3846-1.3845-.7329 0-1.3845.5701-1.3845 1.3845v3.6646h-3.6649c-.733 0-1.3845.57-1.3845 1.385 0 .814.5701 1.384 1.3845 1.384h3.6649v3.665c0 .733.5701 1.385 1.3845 1.385.733 0 1.3846-.57 1.3846-1.385v-3.665h3.6649c.733 0 1.3845-.57 1.3845-1.384 0-.815-.6515-1.385-1.3845-1.385Z"
/>
<defs>
    <linearGradient
        id="a"
        x1="71.6728"
        x2="71.6728"
        y1="27.1805"
        y2="75.3392"
        gradientUnits="userSpaceOnUse"
    >
        <stop stop-color="#B0BACC" /><stop offset="1" stop-color="#969EAE" />
    </linearGradient>
    <linearGradient
        id="d"
        x1="71.636"
        x2="71.636"
        y1="58.3319"
        y2="110.544"
        gradientUnits="userSpaceOnUse"
    >
        <stop stop-color="#FDFEFF" /><stop
            offset=".9964"
            stop-color="#ECF0F5"
        />
    </linearGradient>
    <linearGradient
        id="e"
        x1="71.5699"
        x2="71.5699"
        y1="83.8219"
        y2="105.867"
        gradientUnits="userSpaceOnUse"
    >
        <stop stop-color="#C4CEE0" /><stop offset="1" stop-color="#AAB2C2" />
    </linearGradient>
    <filter
        id="b"
        width="113"
        height="110.5"
        x="15.3652"
        y=".5"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
    >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
            values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.18 0"
        />
        <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1184_4676"
        />
        <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_1184_4676"
            result="shape"
        />
    </filter>
    <filter
        id="c"
        width="134.801"
        height="94.5"
        x="4.26562"
        y="48.5"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
    >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
            values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
        />
        <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1184_4676"
        />
        <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_1184_4676"
            result="shape"
        />
    </filter>
</defs>
